import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-184d273e")

_pushScopeId("data-v-184d273e")
const _hoisted_1 = {
  class: "w-full text-black-lp-100 my-2",
  "aria-describedby": "dana-pinjaman"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", {
      id: "maks-pinjaman",
      rowspan: "2",
      class: "font-bold text-center text-10px py-1 bg-gray-lp-400",
      style: {"border-bottom-color":"#e0e0e0"}
    }, [
      /*#__PURE__*/_createTextVNode(" Maks "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" Pinjaman (Rp.,-) ")
    ]),
    /*#__PURE__*/_createVNode("th", {
      id: "kur",
      colspan: "6",
      class: "font-bold text-center text-10px py-1 bg-gray-lp-400"
    }, " KUR ")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", {
      id: "6",
      class: "font-bold text-center text-10px py-1 bg-gray-lp-400",
      style: {"border-bottom-color":"#e0e0e0"}
    }, "6"),
    /*#__PURE__*/_createVNode("th", {
      id: "12",
      class: "font-bold text-center text-10px py-1 bg-gray-lp-400",
      style: {"border-bottom-color":"#e0e0e0"}
    }, "12"),
    /*#__PURE__*/_createVNode("th", {
      id: "24",
      class: "font-bold text-center text-10px py-1 bg-gray-lp-400",
      style: {"border-bottom-color":"#e0e0e0"}
    }, "24"),
    /*#__PURE__*/_createVNode("th", {
      id: "36",
      class: "font-bold text-center text-10px py-1 bg-gray-lp-400",
      style: {"border-bottom-color":"#e0e0e0"}
    }, "36"),
    /*#__PURE__*/_createVNode("th", {
      id: "48",
      class: "font-bold text-center text-10px py-1 bg-gray-lp-400",
      style: {"border-bottom-color":"#e0e0e0"}
    }, "48"),
    /*#__PURE__*/_createVNode("th", {
      id: "60",
      class: "font-bold text-center text-10px py-1 bg-gray-lp-400",
      style: {"border-bottom-color":"#e0e0e0"}
    }, "60")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("tbody", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "10.000.000"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "1.695.955"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "860.664"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "443.206"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "304.219"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "234.850"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "193.328")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "25.000.000"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "4.239.886"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "2.151.661"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "1.108.015"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "760.548"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "587.126"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "483.320")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "50.000.000"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "8.479.773"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "4.303.321"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "2.216.031"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "1.521.097"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "1.174.251"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "966.640")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "100.000.000"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "16.959.546"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "8.606.643"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "4.432.061"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "3.042.194"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "2.348.503"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "1.933.280")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "200.000.000"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "33.919.091"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "17.213.286"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "8.864.122"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "6.084.387"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "4.697.006"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "3.866.560")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "300.000.000"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "50.878.637"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "25.819.929"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "13.296.183"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "9.126.581"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "7.045.509"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "5.799.840")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "400.000.000"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "67.838.182"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "34.426.572"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "17.728.244"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "12.168.775"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "9.394.012"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "7.733.121")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "500.000.000"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "84.797.728"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "43.033.215"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "22.160.305"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "15.210.969"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "11.742.515"),
    /*#__PURE__*/_createVNode("td", { class: "font-bold text-center text-8px py-1" }, "9.666.401")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("table", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
})